import { AlignmentType } from 'docx'
import {
  createEmptyLine,
  createParagraph,
  createSeparateParagraphs,
} from './docxFunctions'
import { withPresentationFont } from './presentationDocxStyle'

const RUN = withPresentationFont()

/**
 * Позиция регионов: текст из PLP или сводка по «Прочим данным» (критерий «Субъекты»).
 */
export function createRegionsDocxBlocks({
  plpRegionText,
  otherExpertise,
  listLabel,
}) {
  const blocks = []
  const regionText = String(plpRegionText || '').trim()

  if (regionText) {
    blocks.push(
      createParagraph(
        'Позиция органов государственной власти субъектов РФ в сфере охраны здоровья (регионов):',
        { alignment: AlignmentType.JUSTIFIED },
        withPresentationFont({ bold: true })
      )
    )
    blocks.push(
      ...createSeparateParagraphs(
        regionText,
        { alignment: AlignmentType.JUSTIFIED },
        RUN
      )
    )
    blocks.push(createEmptyLine())
    return blocks
  }

  const subjects = otherExpertise?.other?.find(
    o => String(o?.text || '').trim() === 'Субъекты'
  )
  const list = listLabel || 'ЖНВЛП'

  blocks.push(
    createParagraph(
      'Позиция органов государственной власти субъектов РФ в сфере охраны здоровья (регионов):',
      { alignment: AlignmentType.JUSTIFIED },
      RUN
    )
  )

  const placeholders = [
    `-  Х субъектов РФ полагают целесообразным включение ЛП в перечень ЖНВЛП, при этом Х из них отмечает увеличение бюджета;`,
    '-  Х субъектов РФ считают нецелесообразным включение ЛП в перечень ЖНВЛП ввиду отсутствия практики применения;',
    `-  Х субъектов РФ полагает возможным включение ЛП в перечень ЖНВЛП при условии выделения дополнительных средств;`,
    `- Х субъектов РФ отмечает отсутствие пациентов и (или) опыта применения.`,
  ]
  placeholders.forEach(line => {
    blocks.push(
      createParagraph(line, { alignment: AlignmentType.JUSTIFIED }, RUN)
    )
  })

  blocks.push(createEmptyLine())
  return blocks
}
